import React from 'react';

export interface IMarkerSet {
    MARKER_OFF: string;
    MARKER_ON: string;
}

export const QUICK_NAV_EMBEDDED_PANEL_VISIBLE: React.CSSProperties = {
    position: 'sticky',
    top: 0,
    height: '100vh',
    width: '100%',
    backgroundColor: '#1f1f1f',
    overflowY: 'auto',
    overflowX: 'hidden',
    borderRight: '1px solid rgba(255,255,255,0.08)',
};

export const QUICK_NAV_EMBEDDED_PANEL_HIDDEN: React.CSSProperties = {
    ...QUICK_NAV_EMBEDDED_PANEL_VISIBLE,
    display: 'none',
};

export const QUICK_NAV_OVERLAY_CONTENT_STYLE: React.CSSProperties = {
    marginTop: '25px',
    marginLeft: '50px',
    marginBottom: '50px',
    width: '95%',
    transition: '0.6s',
};

export const QUICK_NAV_STACK_TOKENS = { childrenGap: '5px' };
export const QUICK_NAV_CHILD_STACK_TOKENS = { childrenGap: 2 };
export const QUICK_NAV_SECTION_STACK_TOKENS = { childrenGap: 0 };

export const QUICK_NAV_CHILD_STACK_STYLES = { root: { marginLeft: '20px', marginTop: '5px' } };
export const QUICK_NAV_SECTION_STACK_STYLES = { root: { marginLeft: '20px' } };

export const QUICK_NAV_INDENT_STYLE: React.CSSProperties = { marginLeft: '30px' };
export const QUICK_NAV_GROUP_STYLE: React.CSSProperties = { marginLeft: '15px' };

export const QUICK_NAV_STICKY_SEARCH_CONTROLS_STYLE: React.CSSProperties = {
    position: 'sticky',
    top: 0,
    zIndex: 50,
    backgroundColor: '#1f1f1f',
    paddingBottom: 12,
};

export const QUICK_NAV_STICKY_SEGMENT_TITLE_STYLE: React.CSSProperties = {
    position: 'sticky',
    top: '78px',
    zIndex: 40,
    backgroundColor: '#1f1f1f',
    paddingTop: '6px',
    paddingBottom: '6px',
};

export const QUICK_NAV_STICKY_SECTION_TITLE_STYLE: React.CSSProperties = {
    position: 'sticky',
    top: '142px',
    zIndex: 10,
    backgroundColor: '#1f1f1f',
    paddingTop: '6px',
    paddingBottom: '6px',
};
